// Partes visíveis dos drawers de filtro. Para voltar a exibir algo, troque
// para true; o código de cada parte continua nos componentes.
// Filtro desligado também deixa de ser aplicado (o valor é limpo da URL) e
// não faz requisições.

const LISTA_PRODUTOR = {
  // Código da pessoa ao lado do nome (busca por código continua funcionando).
  codigoNaLista: false,
  // Quantidade de entregas/pesagens no período, à direita de cada item.
  quantidadeNaLista: false,
  // Texto abaixo do nome do produtor: 'propriedades' (cadastro de propriedade,
  // pela proidpessoa) ou 'fantasia' (nome fantasia da pessoa).
  subtituloProdutor: 'propriedades',
  // Celular: seletor em tela cheia (busca no topo, teclado não cobre a lista).
  // false = menu do autocomplete, como no computador.
  seletorTelaCheia: false,
  // Celular (sem tela cheia): ao focar, rola o filtro para o teclado não cobrir
  // o menu e devolve a rolagem ao sair do campo.
  ajusteTecladoCelular: true,
};

export const FILTROS_ENTREGAS = {
  ...LISTA_PRODUTOR,
  // Botão de filtro na barra superior e o drawer de filtros.
  exibirFiltros: false,
  // Seleção de produtor. Desligado: lista as entregas de todos os produtores
  // vinculados ao usuário.
  produtor: false,
  // Datas De/Até. Desligado: lista as entregas de todo o período.
  periodo: false,
  // Botões Hoje / 7 dias / Este mês / 30 dias acima das datas.
  atalhosPeriodo: false,
  propriedade: false,
  // Texto "N entregas encontradas" acima dos botões.
  previaTotal: false,
};

export const FILTROS_PESAGENS = {
  ...LISTA_PRODUTOR,
  exibirFiltros: false,
  produtor: false,
  periodo: false,
  atalhosPeriodo: false,
  motorista: false,
  operacao: false,
  situacao: false,
  // Texto "N pesagens encontradas" acima dos botões.
  previaTotal: false,
};

export const FILTROS_FILA = {
  // Escolha Carga / Descarga / Todos. Desligado: usa sempre o tipoPadrao.
  tipo: false,
  // '1' Carga, '2' Descarga, '0' Todos.
  tipoPadrao: '2',
  // Datas De/Até no "Saiu da Empresa". Desligado: traz todas as saídas.
  periodoSaiuEmpresa: false,
};

// Filtro que só vale se o drawer estiver visível e a parte estiver ligada.
export function filtroLigado(config, parte) {
  return !!(config.exibirFiltros && config[parte]);
}
